import { Drawer, DrawerContent, DrawerItem } from "@progress/kendo-react-layout";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import compasslogo from "../../../Assets/CMPLogo.png";
import { showAtlasMenu } from "../../Entry/Manage/EditEntrySignals";
import ConfirmLeavePageDialog from "../../Notification/ConfirmLeavePageDialog";
import {
  showConfigureDataPopover,
  templateHasUnsavedChanges,
} from "../../Template/NewTemplateSignals";
import "./HamburgerMenu.css";
import {
  data,
  isDialogVisible,
  isExpanded,
  items,
  pendingRoute,
  selectedHamburgerIndex,
} from "./HamburgerMenuSignals";

//#region Drawer Item Component ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
const CustomItem = (props) => {
  const { showImage, isExpanded, dataExpanded, isParent, ...others } = props;
  const arrowDir = dataExpanded ? "k-i-arrow-chevron-down" : "k-i-arrow-chevron-right";
  const paddingLeft = others.isChild ? 24 : 16;
  return (
    <>
      {others.visible === false ? null : (
        <DrawerItem
          {...others}
          style={{ paddingLeft: paddingLeft }}
          selected={others.selected}
        >
          <span className={"k-icon " + others.icon} />
          {showImage && isExpanded && (
            <img
              className="hamburger-header-image"
              src={compasslogo}
              alt=""
            />
          )}
          {others.id !== 0 && <span className={"k-item-text"}>{others.label}</span>}
          {isParent && isExpanded && (
            <span
              className={"k-icon " + arrowDir}
              style={{
                position: "absolute",
                right: 10,
              }}
            />
          )}
        </DrawerItem>
      )}
    </>
  );
};
//#endregion ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

const HamburgerMenu = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  //#region UI interactions ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const handleSelect = (ev) => {
    const selectedItem = items.value[ev.itemIndex];
    if (selectedItem.id !== 0) {
      selectedHamburgerIndex.value = selectedItem.id;
    }
    if (selectedItem.id === 0) {
      isExpanded.value = !isExpanded.value;
    } else {
      const isCreateOrEditTemplatePage =
        location.pathname.includes("/templates/create") ||
        location.pathname.includes("/templates/edit");

      if (templateHasUnsavedChanges.value && isCreateOrEditTemplatePage) {
        pendingRoute.value = selectedItem.route;
        isDialogVisible.value = true;
        return;
      }

      navigate(selectedItem.route);
      isExpanded.value && (isExpanded.value = false);
    }
  };

  const handleCancelLeavePageDialog = () => {
    isDialogVisible.value = false;
    pendingRoute.value = null;
  };

  const handleConfirmLeavePageDialog = () => {
    isDialogVisible.value = false;
    if (pendingRoute.value) {
      templateHasUnsavedChanges.value = false;
      navigate(pendingRoute.value);
      isExpanded.value && (isExpanded.value = false);
    }
  };

  const handleOverlayClick = () => {
    isExpanded.value = false;
  };
  //#endregion ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  useEffect(() => {
    document.addEventListener("click", () => {
      if (showConfigureDataPopover.value) {
        showConfigureDataPopover.value = false;
      }
    });
  }, []);

  return (
    <>
      <div className={`custom-overlay ${isExpanded.value ? "visible" : ""}`} />
      {showAtlasMenu.value ? (
        <Drawer
          expanded={isExpanded.value}
          mode={"overlay"}
          mini={showAtlasMenu.value}
          onSelect={handleSelect}
          onOverlayClick={handleOverlayClick}
          items={data.value.map((item) => ({
            ...item,
            isExpanded: isExpanded.value,
          }))}
          item={CustomItem}
        >
          <DrawerContent>
            <div className="main-content">{props.children}</div>
          </DrawerContent>
        </Drawer>
      ) : (
        <div className="main-content">{props.children}</div>
      )}
      {isDialogVisible.value && (
        <ConfirmLeavePageDialog
          handleCancel={handleCancelLeavePageDialog}
          handleConfirm={handleConfirmLeavePageDialog}
        />
      )}
    </>
  );
};
export default HamburgerMenu;
